import { parseISO, isWeekend, startOfMonth, endOfMonth } from 'date-fns'
import Holidays from 'date-holidays'

const frenchHolidays = new Holidays('FR')

/**
 * Renvoie la date la plus récente parmis un tableau de date.
 * @param {[Date]} dates
 */
const mostRecentDate = function (dates) {
  return new Date(Math.max(...dates))
}

const isOpenDay = function (date) {
  return !frenchHolidays.isHoliday(date) && !isWeekend(date)
}

const parseDate = function (date) {
  if (typeof date === 'string') {
    return parseISO(date)
  } else if (typeof date === 'number') {
    return new Date(date)
  } else {
    return date
  }
}

export {
  mostRecentDate,
  isOpenDay,
  parseDate,
  startOfMonth,
  endOfMonth,
  frenchHolidays
}
